import { Injectable } from '@angular/core';
import { ApiProviderProdService } from './api-provider-prod.service';

@Injectable({
  providedIn: 'root'
})
export class ApiProviderService extends ApiProviderProdService {


}
